export enum ValidationErrorObjectType {
  CartProduct = "CartProduct",
  CatalogProduct = "CatalogProduct",
  LineItem = "LineItem",
  Payment = "Payment",
  Shipment = "Shipment",
}
